import { getPrimaryEntityId } from 'app/infrastructure/store/entity';
import { Entity, ComplexValue } from 'app/types-shared';
import { getValue } from 'app/infrastructure/ui/form/selectors';
import { columnName } from 'app/area/case/case-data-model';

export function entityRowsSelector(entities: Entity[], entityType: string) {
  const colNames = columnName[entityType];

  return entities.map((entity) => {
    return {
      id: getPrimaryEntityId(entity),
      name: getValue(entity, colNames.docName).value as string,
      title: getValue(entity, colNames.title).value as string,
      blobId: getValue(entity, colNames.blob).value as number,
      type: getValue(entity, colNames.contentType).value as string,
      size: getValue(entity, colNames.size).value as number,
      thumbnailSize: getValue(entity, colNames.thumbnailSize).value as number,
      attachedBy: getValue(entity, colNames.attachedBy).valueItem as ComplexValue<number>,
      attachedAt: getValue(entity, colNames.attachedAt).value as Date,
      mainImage: getValue(entity, colNames.mainImage).value === 1
    };
  });
}
